import React, { ReactElement, forwardRef } from 'react';
import { Modal } from 'react-bootstrap';
import { Subheader } from '../../containers/Feedback/TabContent/Submissions/Submissions.styles';

export interface ModalProps {
    modalStyle?: React.CSSProperties;
    header?: string | React.JSX.Element;
    headerComponent?: any | undefined;
    headerStyling?: React.CSSProperties;
    body?: string | undefined;
    footer?: any;
    footerStyling?: React.CSSProperties;
    showCloseIcon?: boolean | undefined;
    handleClose?: any;
    show: boolean;
    isStatic?: boolean | undefined;
    subheader?: string | ReactElement;
    className?: string;
    backdropClassName?: string;
    size?: 'sm' | 'lg' | 'xl';
    dialogClassName?: string;
    centered?: boolean;
    children?: any;
    subHeaderClass?: string;
    hideContentOverflow?: boolean;
}

export const ModalComponent = forwardRef(({
    show,
    body,
    modalStyle,
    children,
    className,
    backdropClassName,
    isStatic,
    showCloseIcon,
    headerComponent,
    header,
    headerStyling,
    subheader,
    size,
    footer,
    footerStyling,
    handleClose,
    dialogClassName,
    centered,
    subHeaderClass,
    hideContentOverflow,
}: ModalProps, modalRef) => {

    return (
        <Modal
            show={show}
            style={modalStyle}
            className={className}
            onHide={handleClose}
            backdropClassName={backdropClassName}
            backdrop={isStatic ? "static" : true}
            keyboard={isStatic ? false : true}
            size={size}
            dialogClassName={dialogClassName}
            centered={centered}
            ref={modalRef}
            contentClassName={hideContentOverflow ? 'overflow-hidden' : ""}
        >
            <Modal.Header className={`px-4 ${headerStyling ?? 'border-0'}`} closeButton={showCloseIcon} style={headerStyling ?? {}}>
                {!headerComponent && (
                    <>
                        <Modal.Title className={'h5'}><b>{header}</b></Modal.Title>
                        {!!subheader && <Subheader className={subHeaderClass} style={{ lineHeight: '30px' }}>{subheader}</Subheader>}
                    </>
                )}
                {headerComponent}
            </Modal.Header>
            <Modal.Body className="pt-1 px-4">
                {body}
                {children}
            </Modal.Body>
            {footer && (
                <Modal.Footer  className="px-4" style={footerStyling ?? {}}>
                    {footer}
                </Modal.Footer>
            )}
        </Modal>
    )
})